import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PropertyPresentationDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-property-presentation-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './presentation-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyPresentationDisplayComponent {
  presentation = input.required<PropertyPresentationDto>();
}
